import React from 'react'
import SidebarNew from './SidebarNew'
import NewTopbar from './NewTopbar'
import * as image from "../../resources/images";
// import DonutChart from 'react-donut-chart';
// import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2';
// import { useState,useRef } from 'react';
import DonutChart from './DonutChart';

const HomeDashboardSatic = () => {

 
  return (
     <div className="RootContent ">
    <SidebarNew />
    <div className="main_content">
     <NewTopbar />
     <div className="Content_part flexsix w-100 maincontentpart">
      <div className="leftpannel min-width-100">
       <div className="LeftpanelContent">
        <div className="coursecatalogcontainer">
      
         <div className="mytabList  pb-4 twotabs">
          <ul>
            <li className="w-50 text-center Active_tab">Alex Jr</li>
            <li className="w-50 text-center">Girl jr</li>
          </ul>
         </div>
         <div className='mydashboardgrid'>
          <h2 className='flexthree pb-4'>Plan Overview
         <span className='updownarrow ml-2'>
            <i class="fa-regular fa-angle-up"></i>
            <i class="fa-regular fa-angle-down"></i>
         </span>
         </h2>
             <div className="dashboard-grid">
      
            
            <div className="dashboard-card">
                <h3 className="card-title">Plan Completion Breakdown</h3>
                <div className="card-divider"></div>
                <div className='flexone donutchartwd'>
                <div className="completion-chart">
                    {/* <img src="../assets/images/img_component_25.svg" alt="Completion Chart" width="171" height="171" /> */}
                 {/* <DonutChart
                     data={[
                       {
                        label: 'Give you up',
                        value: 25,
                        innerRadius:10,
                        outerRadius:20
                        },
                      {
                        label: 'leve1',
                        value: 50,
                        innerRadius:10,
                        outerRadius:20
                       
                     },
                          {
                        label: 'leve1',
                        value: 25,
                        innerRadius:10,
                        outerRadius:20
                       
                     },
                 ]}
               />;  */}
               <DonutChart />

                              {/* <Chart       data={donuttData} type='doughnut'/> */}
                </div>
                <div className="chart-legend">
                    <div className="legend-item">
                        <div className="legend-color" style={{backgroundColor:' #85b812'}}></div>
                        <div className="legend-text">62% Completed</div>
                    </div>
                    <div className="legend-item">
                        <div className="legend-color" style={{backgroundColor: '#a86adb'}}></div>
                        <div className="legend-text">18% In Progress</div>
                    </div>
                    <div className="legend-item">
                        <div className="legend-color" style={{backgroundColor: '#e46666'}}></div>
                        <div className="legend-text">20% Not Started</div>
                    </div>
                </div>
                </div>
            </div>
            
            
            <div className="dashboard-card">
                <h3 className="card-title">Weekly Activity Trend</h3>
                <div className="card-divider"></div>
                <div className="activity-chart">
                    <div className="chart-y-axis">
                        <span className="chart-y-label">Minutes Watched</span>
                        <span className="chart-y-label">5</span>
                        <span className="chart-y-label">5</span>
                        <span className="chart-y-label">5</span>
                        <span className="chart-y-label">5</span>
                        <span className="chart-y-label">5</span>
                        <span className="chart-y-label">5</span>
                    </div>
                    {/* <img src="../assets/images/img_mask_group.png" alt="Activity Chart" style={{marginLeft: '40px', width: '350px', height: '171px'}} /> */}

                   {/* <Chart type='line' data={chartData} /> */}

                    <div className="chart-x-axis">
                        <span className="chart-x-label">1</span>
                        <span className="chart-x-label">2</span>
                        <span className="chart-x-label">3</span>
                        <span className="chart-x-label">4</span>
                    </div>
                    <div style={{textAlign: 'center' , marginTop: '5px'}}>
                        <span className="chart-x-label">Weeks</span>
                    </div>
                </div>
            </div>
            
            
            <div className="dashboard-card">
                <h3 className="card-title">Achievements &amp; Milestones</h3>
                <div className="card-divider"></div>
                <div className="achievement-list">
                    <div className="achievement-item">
                        <img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Resolution+Champion.png" alt="Medal" className="achievement-icon" />
                        <div className="achievement-text">"Focus Hero" badge earned on May 10</div>
                    </div>
                    <div className="achievement-item">
                        <img src={image.fireicon} alt="Fire" className="achievement-icon" />
                        <div className="achievement-text">2 Day Streak Started</div>
                    </div>
                    <div className="achievement-item">
                        <img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Codebreaker.png" alt="Trophy" className="achievement-icon" />
                        <div className="achievement-text">Congrats! All badges earned for Understanding Why Teamwork Matters</div>
                    </div>
                </div>
            </div>
            
            
            <div className="dashboard-card okr-section">
                <div className="okr-header">
                    <h2 className="card-title" style={{marginBottom:' 0'}}>Plan OKRs Overview</h2>
                    <div className="view-all">
                        <span>View All Plans</span>
                        {/* <img src="../assets/images/img_humbleiconsarrowup.svg" alt="Arrow" width="24" height="24" /> */}
                        <i class="fa-regular fa-arrow-right-long ml-3"></i>
                    </div>
                </div>
                
                <div className="okr-item">
                    <div className="okr-item-header active" data-target="confident-you">
                        
                        <div className="okr-item-title"><h3 className='h-3'>Confident You: Believe In Yourself</h3></div>
                        {/* <div className="add-button" style={{backgroundColor: '#ffffff', border: 'none'}}> */}
                           <span className="dropdwnicon"><i class="fa-regular fa-angle-down"></i></span>
                        {/* </div> */}
                    </div>
                </div>
                
                <div className="okr-item">
                  <div className="okr-item-header" data-target="teamwork">
                        <div className="okr-item-title">Understanding Why Teamwork Matters</div>
                        {/* <img src="../assets/images/img_vector_cyan_400.svg" alt="Expand" width="14" height="7" /> */}
                        <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                    <div className="okr-item-content active lifeeventlist populattags Child_challenges" id="emotional-you" style={{display: 'block'}}>
                        <div className="okr-divider"></div>
                        <div className="okr-row">
                            <div className="okr-label">Goal</div>
                            <div className="okr-value">Help Alex Jr build lifelong focus habits through structure and self-awareness.</div>
                        </div>
                        <div className="checkbox">
                        <div className='okr-label'>
                                <div className="Ansoptions">
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 1</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                         <div className='okr-label'>
                                <div className="Ansoptions">
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 2</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                               <div className='okr-label'>                                 <div className="Ansoptions">
                                 
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 3</div>
                            </div>

                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                               <div className='okr-label'>     
                                <div className="Ansoptions">
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 3</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                    </div>
                </div>
                
                <div className="okr-item">
                    <div className="okr-item-header" data-target="teamwork">
                        <div className="okr-item-title">Understanding Why Teamwork Matters</div>
                      <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                </div>
                
                <div className="okr-item">
                    <div className="okr-item-header" data-target="problem-skills">
                        <div className="okr-item-title">Developing Super-Human Problem Skills</div>
                         <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                </div>
            </div>
            
            
            <div className="dashboard-card schedule-section">
                <div className="schedule-header">
                    <h2 className="card-title" style={{marginBottom:'0'}}>Plan Schedule</h2>
                    <div className="add-button">
                        <img src="../assets/images/img_vector_white_a700_9x9.svg" alt="Add" width="9" height="9" />
                    </div>
                </div>
                
                <div className="schedule-days">
                    <div className="day-column">
                        <div className="day-header active">Week</div>
                    </div>
                    <div className="day-column">
                        <div className="day-header inactive">Monday</div>
                    </div>
                    <div className="day-column">
                        <div className="day-header inactive">Tuesday</div>
                    </div>
                    <div className="day-column">
                        <div className="day-header inactive">Wednesday</div>
                    </div>
                </div>
                
                <div className="week-row" style={{marginBottom:'0'}}>
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 1</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">5 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                        <div className="day-event">C1: Relationship Building</div>
                        <div className="day-module">M1: Self-Confi...</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date active">7 MAY</div>
                        <div className="day-event">C1: Relationship Building</div>
                        <div className="day-module">M1: Self-Confi...</div>
                    </div>
                </div>
                
                <div className="week-row">
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 2</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">5 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                        <div className="day-event">C1: Relationship Building</div>
                        <div className="day-module">M1: Self-Confi...</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">8 MAY</div>
                    </div>
                </div>
                
                <div className="week-row">
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 3</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">5 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">8 MAY</div>
                    </div>
                </div>
                
                <div className="week-row">
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 4</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">8 MAY</div>
                    </div>
                </div>
            </div>
        </div>
         </div>
          <div className='mydashboardgrid'>
          <h2 className='flexthree pb-4'>Plan Preview
         <span className='updownarrow ml-2'>
            <i class="fa-regular fa-angle-up"></i>
            <i class="fa-regular fa-angle-down"></i>
         </span>
         </h2>
            <div className="dashboard-grid">
            
         <div className="dashboard-card okr-section">
                <div className="okr-header">
                    <h2 className="card-title" style={{marginBottom:' 0'}}>Plan Progress Tracker</h2>
                
                </div>
                
                <div className="">
                <div className='moduleComplete_progress progess_navigation flexone' >
                <div className='modulecpItems completed_modules'>
                <div className='mymodule_name'>
                    <p className='p2'>Confident You: Believe In Yourself</p>
                </div>
                   <ul>
                        <li><span class="circleone"><i class="fa-solid fa-check"></i></span></li>
                        <li><span class="circleone"><i class="fa-solid fa-check"></i></span></li>
                        <li><span class="circleone"><i class="fa-solid fa-check"></i></span></li>
                        <li><span class="circleone"><i class="fa-solid fa-check"></i></span></li>
                        
                    </ul>
                </div>
             <div className='modulecpItems'>
                <div className='mymodule_name'>
                    <p className='p2'>Understanding Why Teamwork Matters</p>
                </div>
                   <ul>
                        <li><span class="circleone"><i class="fa-solid fa-check"></i></span></li>
                        <li><span class="circleone"><i class="fa-solid fa-spinner-scale"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        
                    </ul>
                </div>
             <div className='modulecpItems'>
                <div className='mymodule_name'>
                    <p className='p2'>Developing Super-Human Problem Skills</p>
                </div>
                   <ul>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        
                    </ul>
                </div>
                <div className='modulecpItems '>
                <div className='mymodule_name'>
                    <p className='p2'>Breathwork To Awaken Your Super Energy</p>
                </div>
                   <ul>
                       <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        <li className='locked_modules'><span class="circleone"><i class="fa-solid fa-lock-keyhole"></i></span></li>
                        
                    </ul>
                </div>
                  
                </div>
                </div>
                
              
               
            </div>
            
            
            <div className="dashboard-card">
                <h3 className="card-title">Achievements &amp; Milestones</h3>
                <div className="card-divider"></div>
                <div className="achievement-list">
                    <div className="achievement-item">
                        <img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Resolution+Champion.png" alt="Medal" className="achievement-icon" />
                        <div className="achievement-text">"Focus Hero" badge earned on May 10</div>
                    </div>
                    <div className="achievement-item">
                        <img src={image.fireicon} alt="Fire" className="achievement-icon" />
                        <div className="achievement-text">2 Day Streak Started</div>
                    </div>
                    <div className="achievement-item">
                        <img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Codebreaker.png" alt="Trophy" className="achievement-icon" />
                        <div className="achievement-text">Congrats! All badges earned for Understanding Why Teamwork Matters</div>
                    </div>
                </div>
            </div>
            
            
            <div className="dashboard-card okr-section">
                <div className="okr-header">
                    <h2 className="card-title" style={{marginBottom:' 0'}}>Plan OKRs Overview</h2>
                    <div className="view-all">
                        <span>View All Plans</span>
                        {/* <img src="../assets/images/img_humbleiconsarrowup.svg" alt="Arrow" width="24" height="24" /> */}
                        <i class="fa-regular fa-arrow-right-long ml-3"></i>
                    </div>
                </div>
                
                <div className="okr-item">
                    <div className="okr-item-header active" data-target="confident-you">
                        
                        <div className="okr-item-title"><h3 className='h-3'>Confident You: Believe In Yourself</h3></div>
                        {/* <div className="add-button" style={{backgroundColor: '#ffffff', border: 'none'}}> */}
                           <span className="dropdwnicon"><i class="fa-regular fa-angle-down"></i></span>
                        {/* </div> */}
                    </div>
                </div>
                
                <div className="okr-item">
                  <div className="okr-item-header" data-target="teamwork">
                        <div className="okr-item-title">Understanding Why Teamwork Matters</div>
                        {/* <img src="../assets/images/img_vector_cyan_400.svg" alt="Expand" width="14" height="7" /> */}
                        <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                    <div className="okr-item-content active lifeeventlist populattags Child_challenges" id="emotional-you" style={{display: 'block'}}>
                        <div className="okr-divider"></div>
                        <div className="okr-row">
                            <div className="okr-label">Goal</div>
                            <div className="okr-value">Help Alex Jr build lifelong focus habits through structure and self-awareness.</div>
                        </div>
                        <div className="checkbox">
                        <div className='okr-label'>
                                <div className="Ansoptions">
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 1</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                         <div className='okr-label'>
                                <div className="Ansoptions">
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 2</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                               <div className='okr-label'>                                 <div className="Ansoptions">
                                 
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 3</div>
                            </div>

                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                               <div className='okr-label'>     
                                <div className="Ansoptions">
            <label  className="selAnslabel ">
            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                            <div className="checkbox-label">KR 3</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                    </div>
                </div>
                
                <div className="okr-item">
                    <div className="okr-item-header" data-target="teamwork">
                        <div className="okr-item-title">Understanding Why Teamwork Matters</div>
                      <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                </div>
                
                <div className="okr-item">
                    <div className="okr-item-header" data-target="problem-skills">
                        <div className="okr-item-title">Developing Super-Human Problem Skills</div>
                         <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                </div>
            </div>
            
            
            <div className="dashboard-card schedule-section calendarSchedule">
                <div className="schedule-header">
                    <h2 className="card-title" style={{marginBottom:'0'}}>Plan Schedule</h2>
                    <div className="add-button">
                        {/* <img src="../assets/images/img_vector_white_a700_9x9.svg" alt="Add" width="9" height="9" /> */}
                        <i class="fa-regular fa-plus"></i>
                    </div>
                </div>
                
                    <div className="schedulecalender">
                  <div className="flexone w-100 mt-5">
                    <div className="calander-days week-day-only">
                          <p>Week</p>
                    </div>
                     <div className="calander-days">
                          <p>Monday</p>
                    </div>
                     <div className="calander-days">
                          <p>Tuesday</p>
                    </div>
                     <div className="calander-days">
                          <p>Wednesday</p>
                    </div>
                     <div className="calander-days">
                          <p>Thursday</p>
                    </div>
                     <div className="calander-days">
                          <p>Friday</p>
                    </div>
                     <div className="calander-days">
                          <p>Saturday</p>
                    </div>
                    <div className="calander-days">
                          <p>Sunday</p>
                    </div>
                  </div>

                  {/* Calendar Date */}
                  <div className="flexone w-100 mt-3">
                    {/* 1 secion */}
                    <div className="calander-date-min-div week">
                      <div className="calander-date-title week-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500 weekName">Week 1</p>
                    </div>

                    {/* 2 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 3 secion */}
                    <div className="calander-date-min-div active-date">
                      <div className="calander-date-title active-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <div className="d-flex justify-content-start pl-2">
                          <p className="pt-4 p4 fw-500 calander-date-sub-title">C1: Relationship Building aaaaaaa</p>
                      </div>
                      <div className="d-flex justify-content-start pt-2 pl-2">
                          <i className="fa fa-caret-right mr-1" aria-hidden="true"></i>
                          <p className="calander-date-sub-title1  p3 text-uppercase">M1: Self-Confidence</p>
                      </div>
                    </div>

                    {/* 4 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 5 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 6 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 7 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 8 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>  
                  </div>
                     <div className="flexone w-100 mt-3">
                    {/* 1 secion */}
                    <div className="calander-date-min-div week">
                      <div className="calander-date-title week-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500 weekName">Week 1</p>
                    </div>

                    {/* 2 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 3 secion */}
                    <div className="calander-date-min-div active-date">
                      <div className="calander-date-title active-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <div className="d-flex justify-content-start pl-2">
                          <p className="pt-4 p4 fw-500 calander-date-sub-title">C1: Relationship Building aaaaaaa</p>
                      </div>
                      <div className="d-flex justify-content-start pt-2 pl-2">
                          <i className="fa fa-caret-right mr-1" aria-hidden="true"></i>
                          <p className="calander-date-sub-title1  p3 text-uppercase">M1: Self-Confidence</p>
                      </div>
                    </div>

                    {/* 4 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 5 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 6 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 7 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>

                    {/* 8 secion */}
                    <div className="calander-date-min-div">
                      <div className="calander-date-title">
                        <p className="p3">5 May - 11 MAY</p>
                      </div>
                      <p className="pt-4 p2 fw-500"></p>
                    </div>  
                  </div>
                  </div>
            </div>
        </div>
        </div>
         </div>
         </div>
      </div>
      </div>
      </div>
      </div>
  )
}

export default HomeDashboardSatic
